/* eslint-disable new-cap */
import {MobxReactionUpdate} from '@adobe/lit-mobx';
import {defineCustomElement} from 'extensions/utils';
import {LitElement, html, css, nothing} from 'lit';
import {repeat} from 'lit/directives/repeat.js';

export class Toasts extends MobxReactionUpdate(LitElement) {
	static get styles () {
		return css`
			.toasts {
				left: 0;
				position: fixed;
				right: 0;
				top: 32px;
				width: 100%;
				z-index: 1043;
			}

			@media ( min-width: 768px ) {
				.toasts {
					left: unset;
					right: 32px;
					width: auto;
				}
			}
		`;
	}

	static get properties () {
		return {
			messages: {
				type: Array
			}
		};
	}

	constructor () {
		super();
		this.messages = [];
	}

	renderMessages () {
		if (this.messages?.length > 0) {
			return repeat(
				this.messages,
				(message) => message.id,
				(message) => html`<rb-toast .message="${message}"></rb-toast>`
			);
		}

		return nothing;
	}

	render () {
		return html`
			<div class="toasts">
				${this.renderMessages()}
			</div>
		`;
	}
};

defineCustomElement('rb-toasts', Toasts);
